import { get } from 'lodash';

class AppSelector {
  static modalIsOpen = state => !!get(state, ['app', 'modal']);
}

export default AppSelector;
